export function getErrorMessage(error: unknown, fallback: string): string {
  const serverMsg = (error as any)?.response?.data?.message;
  if (typeof serverMsg === 'string' && serverMsg.length > 0) {
    return serverMsg;
  }
  if (Array.isArray(serverMsg) && serverMsg.length > 0) {
    return serverMsg.join('; ');
  }
  return fallback;
}
